import React, { useState, useEffect } from "react";
import "../styles/index.less";
import {
  Col,
  Row,
  Typography,
  Layout,
  Button,
  Carousel,
  message,
  Form,
  Input,
  Upload,
  Switch,
  Select,
  Radio,
  ColorPicker,
  Tooltip,
  Card,
  Popconfirm,
} from "antd";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { DoubleRightOutlined, UploadOutlined } from "@ant-design/icons";
import {
  announcement_update,
  get_all_announcement,
} from "../../../services/announcement";
import { upload_file } from "../../../services/uploads";
import { useTranslation } from "react-i18next";

// color backgound
const colorOptions = [
  { value: "white", name: "No color" },
  {
    value:
      "linear-gradient(0deg, rgba(238,66,102,1) 0%, rgba(64,31,113,1) 100%)",
    name: "Gradient 1",
  },
  {
    value:
      "linear-gradient(90deg, rgba(66,105,238,1) 0%, rgba(11,228,184,1) 100%)",
    name: "Gradient 2",
  },
  {
    value:
      "linear-gradient(90deg, rgba(218,238,66,1) 0%, rgba(227,11,228,1) 100%)",
    name: "Gradient 3",
  },
  {
    value:
      "linear-gradient(90deg, rgba(15,134,134,1) 0%, rgba(11,228,184,1) 100%)",
    name: "Gradient 4",
  },
  {
    value:
      "linear-gradient(90deg, rgba(70,15,134,1) 0%, rgba(11,228,184,1) 100%)",
    name: "Gradient 5",
  },
];

const { Title } = Typography;
const { Content } = Layout;

type Props = {};

const CreateBanner = (props: Props) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const params = useParams();
  const { t } = useTranslation();
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [uploadDisabled, setUploadDisabled] = useState(false);
  const { name_announcement } = useParams<{ name_announcement: string }>();
  const [announcementId, setAnnouncementId] = useState<string | null>(null);
  const [valueTitle, setValueTitle] = useState<{ colortitle: string }>({
    colortitle: "#1677ff",
  });
  const [valuedetail, setValuedetail] = useState<{ colordetail: string }>({
    colordetail: "#1677ff",
  });
  const [valuebutton, setValuebutton] = useState<{ colorbutton: string }>({
    colorbutton: "#1677ff",
  });
  const [valuebackground, setValuebackground] = useState<{
    colorbackground: string;
  }>({ colorbackground: "#1677ff" });
  const [isLoading, setIsLoading] = useState(false);
  const [readMore, setReadMore] = useState(false);
  const [formData, setFormData] = useState({
    backcolor: "",
    detail: "",
    readMore: false,
    summarize: "",
    textPosition: "",
    url: "",
    colortitle: "",
    colordetail: "",
    colorbutton: "",
    colorbackground: "",
  });
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [_, forceUpdate] = useState({});
  const [announcementname, setAnnouncementName] = useState<string | null>(null);

  // upload image
  const beforeUpload = (file: File) => {
    const url = URL.createObjectURL(file);
    setImageUrls([...imageUrls, url]);
    setUploadDisabled(true);
    return false;
  };

  const getBase64 = (file: File, callback: (imageUrl: string) => void) => {
    const reader = new FileReader();
    reader.onload = () => callback(reader.result as string);
    reader.readAsDataURL(file);
  };

  // submit data
  const handleFormChange = (changedValues: any, allValues: any) => {
    setFormData(allValues);
  };

  // swicth readmore
  const handleReadMoreChange = (checked: any) => {
    setReadMore(checked);
  };

  // convert color to hex for seve in database
  const handleColorChangeTitle = (color: { hex?: string }) => {
    const hexColorTitle = color.hex || color;
    // setValueTitle(hexColorTitle);
    form.setFieldsValue({ colortitle: hexColorTitle });
  };

  const handleColorChangeDetail = (color: { hex?: string }) => {
    const hexColorDetail = color.hex || color;
    form.setFieldsValue({ colordetail: hexColorDetail });
  };

  const handleColorChangeButton = (color: { hex?: string }) => {
    const hexColorButton = color.hex || color;
    // setValueDetail(hexColor);
    form.setFieldsValue({ colorbutton: hexColorButton });
  };

  const handleColorChangeBackground = (color: { hex?: string }) => {
    const hexColorBackground = color.hex || color;
    // setValueDetail(hexColor);
    form.setFieldsValue({ colorbackground: hexColorBackground });
  };

  // api Announce
  useEffect(() => {
    getAnnounce();
    getAnnouncebyid();
  }, []);

  useEffect(() => {
    if (params.action === "edit") {
      getAnnouncebyid();
    }
  }, [params.action, name_announcement]);

  const getAnnounce = async () => {
    try {
      const res = await get_all_announcement();
      if (res.result && Array.isArray(res.result)) {
        const matchedAnnounce = res.result.find(
          (item: { title: string | undefined }) =>
            item.title === name_announcement
        );
        if (matchedAnnounce) {
          setAnnouncementId(matchedAnnounce.announcement_id);
        } else {
          console.warn("⚠️ No matching announcement found.");
        }
      }
    } catch (error) {
      console.error("❌ Error fetching announcements:", error);
    }
  };

  const createannouncement = async () => {
    setIsLoading(true);
    try {
      const titleValue =
        params.action === "new" ? name_announcement : announcementname;
      // ✅ เตรียมข้อมูล
      const data = {
        announcement_id: announcementId,
        title: form.getFieldValue("title"),
        img: form.getFieldValue("image"),
        link: null,
        content: [
          {
            details: [
              {
                url: form.getFieldValue("url") ?? "",
                textPosition: form.getFieldValue("textPosition") ?? null,
                detail: form.getFieldValue("detail") ?? "",
                colortitle: form.getFieldValue("colortitle") ?? "",
                colorPickerTitle: form.getFieldValue("colorPickerTitle") ?? "",
                summarize: form.getFieldValue("summarize") ?? "",
                colordetail: form.getFieldValue("colordetail") ?? "",
                colorPickerDetail:
                  form.getFieldValue("colorPickerDetail") ?? "",
                backcolor: form.getFieldValue("backcolor") ?? "",
                colorbackground: form.getFieldValue("colorbackground") ?? "",
                colorPickerBackground:
                  form.getFieldValue("colorPickerBackground") ?? "",
                readMore: form.getFieldValue("readMore") ?? false,
                colorbutton: form.getFieldValue("colorbutton") ?? "",
              },
            ],
          },
        ],
      };
      // ✅ เรียก API
      const res = await announcement_update(data);
      if (res.status === "success") {
        message.success(
          params.action === "new" ? "Create Success!" : "Update Success!"
        );
        navigate("/announcement");
        window.scrollTo(0, 0);
      } else {
        message.error("❌ API call failed: " + JSON.stringify(res));
      }
    } catch (e) {
      console.error("❌ Error:", e);
      message.error("Error occurred while updating data.");
    }
    setIsLoading(false);
  };

  const getAnnouncebyid = async () => {
    try {
      const res = await get_all_announcement();
      if (res.result && Array.isArray(res.result)) {
        const matchedAnnounce = res.result.find(
          (item: { announcement_id: string | undefined }) =>
            item.announcement_id === params.task_id
        );

        if (matchedAnnounce) {
          setAnnouncementId(matchedAnnounce.announcement_id);
          setAnnouncementName(matchedAnnounce.title);

          let parsedContent = [];
          try {
            parsedContent = matchedAnnounce.content
              ? JSON.parse(matchedAnnounce.content)
              : [];
          } catch (error) {
            console.error("❌ Error parsing content JSON:", error);
          }

          const details = parsedContent?.[0]?.details?.[0] || {};

          // ✅ อัปเดตค่าลงใน Form
          form.setFieldsValue({
            title: matchedAnnounce.title,
            image: matchedAnnounce.img || "",
            textPosition: details.textPosition || "left",
            detail: details.detail || "",
            colortitle: details.colortitle || "",
            summarize: details.summarize || "",
            colordetail: details.colordetail || "",
            backcolor: details.backcolor || "",
            colorbackground: details.colorbackground || "",
            readMore: details.readMore || false,
            url: details.url || "",
            colorbutton: details.colorbutton || "",
          });

          // ✅ อัปเดต formData สำหรับแสดงใน Carousel
          setFormData({
            textPosition: details.textPosition || "left",
            detail: details.detail || "",
            colortitle: details.colortitle || "",
            summarize: details.summarize || "",
            colordetail: details.colordetail || "",
            backcolor: details.backcolor || "",
            colorbackground: details.colorbackground || "",
            readMore: details.readMore || false,
            url: details.url || "",
            colorbutton: details.colorbutton || "",
          });

          if (matchedAnnounce.img) {
            setImageUrls([matchedAnnounce.img]);
          }
          forceUpdate({});
        } else {
          console.warn("⚠️ No matching announcement found.");
        }
      }
    } catch (error) {
      console.error("❌ Error fetching announcements:", error);
    }
  };



  return (
    <div>
      {/* preview Carousel */}
      <Content style={{ padding: "0px 20px 20px 20px" }}>
        <h2 style={{ textAlign: "center", paddingTop: "20px" }}>{t("Preview")}</h2>
        <Carousel>
          {imageUrls.length === 0 ? (
            <div>
              <Row
                align="middle"
                className="carouselmain"
                style={{
                  // height: "500px",
                  background:
                    formData.colorbackground || formData.backcolor || "#FFFFFF",
                  border:
                    formData.colorbackground || formData.backcolor
                      ? "none"
                      : "1px solid #DADADA",
                  borderRadius: "10px",
                }}
              >
                {formData.detail && formData.summarize ? (
                  <>
                    {formData.textPosition === "left" && (
                      <>
                        <Col span={12} style={{ paddingLeft: "50px" }}>
                          <div
                            className="title-head"
                            style={{ paddingRight: "50px", marginTop: "0px" }}
                          >
                            <Title
                              level={3}
                              className="title-level-3-2"
                              style={{ color: formData.colortitle }}
                            >
                              {formData.detail}
                            </Title>
                            <p
                              className="title-level-3-3"
                              style={{ color: formData.colordetail }}
                            >
                              {formData.summarize}
                            </p>
                            {formData.readMore && (
                              <Button
                                type="link"
                                className="button-banner"
                                target="_blank"
                                style={{
                                  backgroundColor: formData.colorbutton,
                                }}
                              >
                                Read More <DoubleRightOutlined />
                              </Button>
                            )}
                          </div>
                        </Col>
                        <Col span={12}></Col>
                      </>
                    )}

                    {formData.textPosition === "right" && (
                      <>
                        <Col span={12}></Col>
                        <Col span={11} style={{ paddingLeft: "50px" }}>
                          <div
                            className="title-head"
                            style={{ paddingRight: "50px", marginTop: "0px" }}
                          >
                            <Title
                              level={3}
                              className="title-level-3-2"
                              style={{ color: formData.colortitle }}
                            >
                              {formData.detail}
                            </Title>
                            <p
                              className="title-level-3-3"
                              style={{ color: formData.colordetail }}
                            >
                              {formData.summarize}
                            </p>
                            {formData.readMore && (
                              <Button
                                type="link"
                                className="button-banner"
                                target="_blank"
                                style={{
                                  backgroundColor: formData.colorbutton,
                                }}
                              >
                                Read More <DoubleRightOutlined />
                              </Button>
                            )}
                          </div>
                        </Col>
                      </>
                    )}

                    {formData.textPosition === "center" && (
                      <>
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            display: "inline-block",
                          }}
                        >
                          <div
                            className="title-head"
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              textAlign: "center",
                              color: "#fff",
                            }}
                          >
                            <Title
                              level={3}
                              className="title-level-3-2"
                              style={{ color: formData.colortitle }}
                            >
                              {formData.detail}
                            </Title>
                            <p
                              className="title-level-3-3"
                              style={{ color: formData.colordetail }}
                            >
                              {formData.summarize}
                            </p>
                            {formData.readMore && (
                              <Button
                                type="link"
                                className="button-banner"
                                target="_blank"
                                style={{
                                  backgroundColor: formData.colorbutton,
                                }}
                              >
                                Read More <DoubleRightOutlined />
                              </Button>
                            )}
                          </div>
                        </div>
                      </>
                    )}
                  </>
                ) : (
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                      height: "100%",
                    }}
                  >
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "40px",
                        lineHeight: "500px",
                      }}
                    >
                      Preview
                    </div>
                    {formData.readMore && (
                      <Button
                        type="link"
                        className="button-banner"
                        target="_blank"
                        style={{ backgroundColor: formData.colorbutton }}
                      >
                        Read More <DoubleRightOutlined />
                      </Button>
                    )}
                  </div>
                )}
              </Row>
            </div>
          ) : (
            imageUrls.map((url, index) => (
              <div key={index}>
                <Row
                  align="middle"
                  className="carouselmain"
                  style={{
                    // height: "400px",
                    background:
                      formData.colorbackground ||
                      formData.backcolor ||
                      "#FFFFFF",
                    border:
                      formData.colorbackground || formData.backcolor
                        ? "none"
                        : "1px solid #DADADA",
                    borderRadius: "10px",
                  }}
                >
                  {formData.detail || formData.summarize ? (
                    <>
                      {formData.textPosition === "left" && (
                        <>
                          <Col span={12} style={{ paddingLeft: "50px" }}>
                            <div
                              className="title-head"
                              style={{ paddingRight: "50px", marginTop: "0px" }}
                            >
                              <Title
                                level={3}
                                className="title-level-3-2"
                                style={{ color: formData.colortitle }}
                              >
                                {formData.detail}
                              </Title>
                              <p
                                className="title-level-3-3"
                                style={{ color: formData.colordetail }}
                              >
                                {formData.summarize}
                              </p>
                              {formData.readMore && (
                                <Button
                                  type="link"
                                  className="button-banner"
                                  target="_blank"
                                  style={{
                                    backgroundColor: formData.colorbutton,
                                  }}
                                >
                                  Read More <DoubleRightOutlined />
                                </Button>
                              )}
                            </div>
                          </Col>
                          <Col span={12}>
                            <Row
                              justify="center"
                              align="middle"
                              style={{ paddingRight: "20px" }}
                            >
                              <Col>
                                <img
                                  // src={`${process.env.REACT_APP_API}${item.img}`}
                                  // src={url}
                                  src={
                                    params.action === "new"
                                      ? url
                                      : `${process.env.REACT_APP_API}${url}`
                                  }
                                  alt={`uploaded-${index}`}
                                  className="title-image"
                                  style={{ borderRadius: 20, height: 300 }}
                                />
                              </Col>
                            </Row>
                          </Col>
                        </>
                      )}

                      {formData.textPosition === "right" && (
                        <>
                          <Col span={12}>
                            <Row
                              justify="center"
                              align="middle"
                              style={{ paddingRight: "20px" }}
                            >
                              <Col>
                                <img
                                  // src={url}
                                  src={
                                    params.action === "new"
                                      ? url
                                      : `${process.env.REACT_APP_API}${url}`
                                  }
                                  alt={`uploaded-${index}`}
                                  className="title-image"
                                  style={{ borderRadius: 20, height: 300 }}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col span={12} style={{ paddingLeft: "50px" }}>
                            <div
                              className="title-head"
                              style={{ paddingRight: "50px", marginTop: "0px" }}
                            >
                              <Title
                                level={3}
                                className="title-level-3-2"
                                style={{ color: formData.colortitle }}
                              >
                                {formData.detail}
                              </Title>
                              <p
                                className="title-level-3-3"
                                style={{ color: formData.colordetail }}
                              >
                                {formData.summarize}
                              </p>
                              {formData.readMore && (
                                <Button
                                  type="link"
                                  className="button-banner"
                                  target="_blank"
                                  style={{
                                    backgroundColor: formData.colorbutton,
                                  }}
                                >
                                  Read More <DoubleRightOutlined />
                                </Button>
                              )}
                            </div>
                          </Col>
                        </>
                      )}

                      {formData.textPosition === "center" && (
                        <>
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              display: "inline-block",
                            }}
                          >
                            <img
                              // src={url}
                              src={
                                params.action === "new"
                                  ? url
                                  : `${process.env.REACT_APP_API}${url}`
                              }
                              alt={`uploaded-${index}`}
                              className="title-image"
                              style={{
                                width: "100%",
                                height: "100%",
                                borderRadius: "10px",
                              }}
                            />
                            <div
                              className="title-head"
                              style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                textAlign: "center",
                                color: "#fff",
                              }}
                            >
                              <Title
                                level={3}
                                className="title-level-3-2"
                                style={{ color: formData.colortitle }}
                              >
                                {formData.detail}
                              </Title>
                              <p
                                className="title-level-3-3"
                                style={{ color: formData.colordetail }}
                              >
                                {formData.summarize}
                              </p>
                              {formData.readMore && (
                                <Button
                                  type="link"
                                  className="button-banner"
                                  target="_blank"
                                  style={{
                                    backgroundColor: formData.colorbutton,
                                  }}
                                >
                                  Read More <DoubleRightOutlined />
                                </Button>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  ) : (
                    <div
                      style={{
                        position: "relative",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      <img
                        // src={url}
                        src={
                          params.action === "new"
                            ? url
                            : `${process.env.REACT_APP_API}${url}`
                        }
                        alt={`uploaded-${index}`}
                        className="title-image"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "10px",
                        }}
                      />
                      {formData.readMore && (
                        <Button
                          type="link"
                          className="button-banner"
                          target="_blank"
                          style={{
                            position: "absolute",
                            bottom: "20px",
                            left: "20px",
                            backgroundColor: formData.colorbutton,
                          }}
                        >
                          Read More <DoubleRightOutlined />
                        </Button>
                      )}
                    </div>
                  )}
                </Row>
              </div>
            ))
          )}
        </Carousel>
      </Content>

      {/* input data */}
      <Content style={{ padding: "20px 20px 20px 20px" }}>
        <Card
          title={t("create announcement")}
          style={{
            width: "100%",
            backgroundColor: "#F3F3F1",
            borderColor: "#cccccc",
          }}
        >
          <Form
            form={form}
            name="basic"
            initialValues={{ remember: true }}
            layout="vertical"
            onValuesChange={handleFormChange}
            onFinish={createannouncement}
          >
            <Form.Item
              label={t("name announcement")}
              name="title"
              initialValue={name_announcement}
            >
              <Input />
            </Form.Item>

            <Row gutter={8} align="middle">
              <Col flex="auto">
                <Form.Item label={t("upload announcement")} name="image">
                  <Input
                    placeholder="Link image"
                    disabled
                    // ={!!form.getFieldValue("image")}
                  />
                </Form.Item>
              </Col>
              <Col>
                {form.getFieldValue("image") ? (
                  <Tooltip placement="bottom" title="Clear Path">
                    <Button
                      danger
                      icon={"X"}
                      onClick={() => {
                        setImageUrl(null);
                        form.setFieldsValue({ image: null });
                        forceUpdate({});
                      }}
                    />
                  </Tooltip>
                ) : (
                  <Tooltip placement="bottom" title="Upload">
                    <Upload
                      beforeUpload={beforeUpload}
                      showUploadList={false}
                      maxCount={1}
                      onChange={async (info: any) => {
                        if (info.fileList.length > 0) {
                          const file = info.fileList[0].originFileObj;
                          const fileName = info.fileList[0].name;

                          getBase64(file, (imageUrl: string) => {
                            setImageUrl(imageUrl);
                          });

                          try {
                            const uploadResponse = await upload_file({
                              task_id: "banner_image",
                              type: "banner",
                              name: fileName,
                              file: file,
                            });

                            if (uploadResponse.status === "success") {
                              form.setFieldsValue({
                                image: uploadResponse.link,
                              });
                              forceUpdate({});
                            } else {
                              console.warn("Failed to upload image.");
                            }
                          } catch (uploadError) {
                            console.error(
                              "❌ Error uploading image:",
                              uploadError
                            );
                            message.error("Failed to upload image.");
                          }
                        }
                      }}
                    >
                      <Button
                        style={{
                          backgroundColor: "#0E21A0",
                          color: "white",
                        }}
                        icon={<UploadOutlined />}
                      ></Button>
                    </Upload>
                  </Tooltip>
                )}
              </Col>

              <Col xs={24} md={12}>
                <Form.Item
                  label={t("text position")}
                  name="textPosition"
                  rules={[
                    {
                      required: true,
                      message: "Please select the text position!",
                    },
                  ]}
                >
                  <Radio.Group>
                    <Radio value="left">{t("left")}</Radio>
                    <Radio value="center">{t("center")}</Radio>
                    <Radio value="right">{t("right")}</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={8} align="middle">
              <Col flex="auto">
                <Form.Item
                  label={t("title announcement")}
                  name="detail"
                  rules={[
                    {
                      required: true,
                      message: "Please input your detail!",
                    },
                  ]}
                  style={{ marginRight: "10px" }}
                >
                  <Input showCount maxLength={12} />
                </Form.Item>
              </Col>

              <Col flex="auto" style={{ display: "none"}}>
                <Form.Item
                  name="colortitle"
                  label="Color Title"
                  rules={[
                    { required: false, message: "Please select a color!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item name="colorPickerTitle" label=" ">
                  <ColorPicker
                    value={valueTitle.colortitle}
                    onChange={(color, hex) => handleColorChangeTitle({ hex })}
                    format="hex"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={8} align="middle">
              <Col flex={2}>
                <Form.Item
                  label={t("detail announcement")}
                  name="summarize"
                  style={{ marginRight: "10px" }}
                  rules={[
                    {
                      required: true,
                      message: "Please input your summarize!",
                    },
                  ]}
                >
                  <Input showCount maxLength={80} />
                </Form.Item>
              </Col>

              <Col flex={2} style={{ display: "none"}}>
                <Form.Item
                  name="colordetail"
                  label="Color Detail"
                  rules={[
                    { required: false, message: "Please select a color!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item name="colorPickerDetail" label=" ">
                  <ColorPicker
                    value={valuedetail.colordetail}
                    onChange={(color, hex) => handleColorChangeDetail({ hex })}
                    format="hex"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={8} align="middle">
              <Col flex="auto">
                <Form.Item
                  label={t("background color")}
                  name="backcolor"
                  rules={[
                    {
                      required: false,
                      message: "Please select the background color!",
                    },
                  ]}
                  style={{ marginRight: "10px" }}
                >
                  <Select>
                    {colorOptions.map((option) => (
                      <Select.Option key={option.value} value={option.value}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              background: option.value,
                              height: "20px",
                              width: "50px",
                              borderRadius: "4px", // เพิ่มมุมโค้งถ้าต้องการให้ดูนุ่มนวล
                            }}
                          />
                          <span style={{ marginLeft: "10px" }}>
                            {option.name}
                          </span>
                        </div>
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>

              <Col style={{ display: "none"}}>
                <Form.Item
                  name="colorbackground"
                  label="Color Background"
                  rules={[
                    { required: false, message: "Please select a color!" },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col>
                <Form.Item name="colorPickerBackground" label=" ">
                  <ColorPicker
                    value={valuebackground.colorbackground}
                    onChange={(color, hex) =>
                      handleColorChangeBackground({ hex })
                    }
                    format="hex"
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col>
                <Form.Item
                  label="ปุ่ม (Read more)"
                  name="readMore"
                  valuePropName="checked"
                >
                  <Switch onChange={handleReadMoreChange} />
                </Form.Item>
              </Col>
            </Row>

            {form.getFieldValue("readMore") && (
              <Row gutter={8} align="middle">
                <Col span={12}>
                  <Form.Item
                    name="url"
                    label="URL"
                    rules={[
                      { required: true, message: "Please input your URL!" },
                      { type: "url", warningOnly: true },
                    ]}
                  >
                    <Input placeholder="input placeholder" />
                  </Form.Item>
                </Col>

                <Col flex="auto" style={{ display: "none"}}>
                  <Form.Item
                    name="colorbutton"
                    label="Color Button"
                    rules={[
                      { required: false, message: "Please select a color!" },
                    ]}
                    style={{ marginLeft: "10px" }}
                  >
                    <Input />
                  </Form.Item>
                </Col>

                <Col>
                  <Form.Item name="colorPickerButton" label=" ">
                    <ColorPicker
                      value={valuebutton.colorbutton}
                      onChange={(color, hex) =>
                        handleColorChangeButton({ hex })
                      }
                      format="hex"
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Form.Item>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: "30px",
                }}
              >
                <Popconfirm
                  title={t("Alert title")}
                  description={t("Alert cancel announcement")}
                  onConfirm={() => navigate("/announcement")} // นำทางเมื่อกดตกลง
                  okText={t("yes")}
                  cancelText={t("no")}
                >
                  <Button style={{ margin: "0 8px" }}>
                    {t("cancel")}
                  </Button>
                </Popconfirm>
                <Popconfirm
                  title={params.action === "new" ? t("Alert confirm create title") : t("Alert confirm update title")}
                  description={params.action === "new" ? t("Alert create detail announcement") : t("Alert update detail announcement")}
                  onConfirm={() => form.submit()} // ดำเนินการ submit form เมื่อกดตกลง
                  okText={t("yes")}
                  cancelText={t("no")}
                >
                  <Button loading={isLoading} type="primary" htmlType="button">
                    {params.action === "new" ? t("create announcement") : t("update Announcement")}
                  </Button>
                </Popconfirm>
              </div>
            </Form.Item>
          </Form>
        </Card>

        {/* </div> */}
      </Content>
    </div>
  );
};

export default CreateBanner;
